export default {
  modelName: 'meeting_template_field',
  label: '議事模板欄位',
  fields: {
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    name: {
      label: '名稱',
      type: 'text',
      width: '300px',
      readonly: true,
    },
    module: {
      type: 'select',
      rules: 'required',
      label: '模組',
      items: [
        {
          value: 'meeting',
          text: '議事',
        },
        {
          value: 'meeting_item',
          text: '議案',
        },
      ],
      defaultValue: '',
    },
    value: {
      type: 'text',
      rules: 'required',
      label: 'value',
      width: '300px',
    },
    data_field: {
      type: 'text',
      label: '對應到前台的資料庫欄位',
      width: '300px',
      // 可以看 notion
    },
    has_xml: {
      type: 'switch',
      label: '是否有使用Word的XML格式',
      defaultValue: false,
    },
    has_html: {
      type: 'switch',
      label: '是否有使用HTML格式',
      defaultValue: false,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          width: '300px',
          rules: 'required',
          maxlength: 100,
        },
      },
    },
    is_active: {
      type: 'switch',
      label: '啟用',
      defaultValue: true,
    },
    is_record: {
      type: 'switch',
      label: '前台資料庫是否紀錄',
      defaultValue: true,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
  },
};
